<template>
  <section id="tales" class="container" aria-label="follow a birder">
    <h2 class="follow-birder-title">{{ title }}</h2>
    <div class="follow-birder-subtitle">{{ subtitle }}</div>
    <p class="follow-birder-description">{{ description }}
    </p>
    <div class="birder-grid">
      <birder-card v-for="(birder, index) in birders" :key="index" :name="birder.name" :avatar="birder.avatar"
        :video_url="birder.video_url" :index="index" />
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BirderCard from './BirderCard.vue';

@Component({
  name: 'FollowABirder',
  components: {
    BirderCard,
  },
  props: {
    title: {
      type: String,
      default: 'Birding Adventures Unveiled',
    },
    subtitle: {
      type: String,
      default: 'Encounters in Alabama\'s Breathtaking Landscapes',
    },
    description: {
      type: String,
      default: 'Embark on a captivating birding adventure in Alabama! Join passionate birders as we follow their exciting journeys through stunning landscapes. Select a birder and watch their thrilling encounters with avian wonders in captivating videos. Discover Alabama\'s rich birdlife and why it attracts enthusiasts from across the globe. Let curiosity take flight as you explore this extraordinary expedition.',
    },
    birders: {
      type: Array,
      default: [],
    },
  },
})
class FollowABirder extends Vue {
}
export default FollowABirder;
</script>

<style scoped>
section {
  margin-top: 125px;
  margin-bottom: 125px;
}

h2.follow-birder-title {
  font-family: 'klinicslabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 1.1em;
  align-items: center;
  margin-bottom: 1rem;
  text-align: center;
  color: #173945;
}

.follow-birder-subtitle {
  font-family: 'klinicslabbook';
  font-style: 'normal';
  font-weight: 400;
  font-size: 24px;
  line-height: 1.1em;
  overflow: wrap;
  align-items: center;
  text-align: center;
  color: #173945;
  margin-bottom: 1rem;
}

.follow-birder-description {
  font-family: 'IdealSans-Book', 'Avenir', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  width: 70%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin: 0 auto;
  text-align: center;
  color: #173945;

  @media only screen and (max-width: 936px) {
    width: 100%;
  }

}

.birder-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto-fill, 220px);
  box-sizing: border-box;
  width: 800px;
  height: auto;
  gap: 1em;
  margin: 2em auto 0 auto;
  justify-content: space-evenly;
  justify-items: center;
  align-content: space-evenly;
  align-items: first baseline;

  @media only screen and (max-width: 936px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    margin-left: 0;
  }
}
</style>
